import { Input, KeyCode } from "../../../lib/Input";
import Ability from "../../Ability";
import Player from "../../Player";

export default class Fortify extends Ability {

    constructor(player: Player) {
        super(player, {
            cooldown: 15,
            duration: 6,
            energyCost: 30,
            icon: 3,
            trigger: KeyCode.Digit1,
            triggerType: Input.GetKeyDown,
            info: `Fortify (15s cooldown) - Activates reinforced armor, reducing incoming damage by 50% for 6 seconds.`
        })
    }

    onDurationEnd(): void {
        this.player.damageReductionModifier = 0;
    }

    onUse(): void {
        this.player.damageReductionModifier = 0.5;
    }
}